import React, { useCallback, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { getTutorBookingsPage } from "../../../services/dataService";
import { SESSION_FILTERS, sessionsZoneNote } from "../../../utils/studentDetail";
import { showingLabel } from "../../../utils/kitPresentation";
import { TableCard } from "../../../components/kit/SectionCard";
import Pager from "../../../components/kit/Pager";
import ToolbarMenu from "../../../components/kit/ToolbarMenu";
import { PAGE_SIZE } from "../../Students/tabs/TabState";
import { usePagedQuery } from "../../Students/tabs/usePagedQuery";
import { useUsersByIds } from "../../Students/tabs/useUsersByIds";
import SessionsTable from "../../Students/tabs/SessionsTable";
import { useChildNames } from "./useChildNames";

// Every lesson this tutor teaches, newest first (047 D44): the student tab's Status menu and
// queries, on teacherId — "All" on (teacherId, startTimeUTC desc), a status on
// (teacherId, status, startTimeUTC desc). Upcoming and Awaiting outcome split Pending at the
// moment the choice was made (044 D38). Students and children are read once per tab.
const SessionsTab = () => {
  const { tutor } = useOutletContext();
  const uid = tutor.id;
  const [filter, setFilter] = useState("all");
  const [now, setNow] = useState(() => new Date());

  const current = SESSION_FILTERS.find((f) => f.key === filter);
  const { status, when } = current;
  const fetchPage = useCallback(
    (cursor) => getTutorBookingsPage(uid, { status, when, now, pageSize: PAGE_SIZE, cursor }),
    [uid, status, when, now]
  );
  const sessions = usePagedQuery(fetchPage, filter, "Failed to load the sessions.");
  const usersById = useUsersByIds(sessions.rows.map((b) => b.studentId));
  const childrenById = useChildNames(sessions.rows);

  // ToolbarMenu calls this only for a new choice, so picking the current one keeps the page.
  const choose = (key) => {
    setFilter(key);
    setNow(new Date());
  };

  return (
    <TableCard
      title="Sessions"
      subtitle={`Newest first · open a row to act on the lesson · ${sessionsZoneNote(sessions.rows, { timeZone: tutor.timeZone, forTutor: true })}`}
      toolbar={<ToolbarMenu id="tutor-sessions-status" label="Status" value={filter} options={SESSION_FILTERS} onChange={choose} />}
      footer={
        <Pager
          label={sessions.loading || sessions.error ? "" : showingLabel(sessions.page, sessions.rows.length, PAGE_SIZE)}
          page={sessions.page}
          hasMore={sessions.hasMore}
          onPage={sessions.load}
        />
      }
    >
      <SessionsTable
        forTutor
        rows={sessions.rows}
        childrenById={childrenById}
        usersById={usersById}
        timeZone={tutor.timeZone}
        loading={sessions.loading}
        error={sessions.error}
        onRetry={() => sessions.load(sessions.page)}
        emptyText={current.empty}
      />
    </TableCard>
  );
};

export default SessionsTab;
